import { useEffect, useState } from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import AddIcon from "@mui/icons-material/Add";
import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";
import { findAll, remove, save } from "./api-curso";
import { errorMessage } from "../../util/ConfirmAlertUtil";
import { success } from "../../util/ToastUtil";
import Container from "../UI/Container";
import CursoForm from "./CursoForm";
import CursoTable from "./CursoTable";

const porDescricao = (a, b) => (a.descricao ?? "").localeCompare(b.descricao ?? "", "pt-BR");
const ordenar = (lista) => [...lista].sort(porDescricao);
const mensagemDe = (data, padrao) =>
  [].concat(data?.message ?? []).filter(Boolean).join("\n") || padrao;

export default function CursoContainer() {
  const [cursos, setCursos] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [editando, setEditando] = useState(null);
  const [isSaving, setIsSaving] = useState(false);

  useEffect(() => {
    findAll()
      .then((data) => {
        if (!data) return;
        if (data.error) {
          errorMessage(mensagemDe(data, "Não foi possível carregar os cursos."));
        } else if (Array.isArray(data)) {
          setCursos(ordenar(data));
        }
      })
      .finally(() => setIsLoading(false));
  }, []);

  const handleSave = (persist) => {
    const eNovo = !persist.codCurso;
    setIsSaving(true);
    save(persist)
      .then((data) => {
        if (!data || data.error) {
          errorMessage(mensagemDe(data, "Não foi possível salvar o curso."));
          return;
        }
        setCursos((prevState) =>
          ordenar(eNovo ? [...prevState, data] : prevState.map((c) => (c.codCurso === data.codCurso ? data : c))),
        );
        setEditando(null);
        success("Salvo com sucesso.");
      })
      .finally(() => setIsSaving(false));
  };

  const handleDelete = (curso) =>
    confirmAlert({
      title: "Alerta",
      message: `Deseja remover o curso "${curso.descricao}"?`,
      buttons: [
        {
          label: "Sim",
          onClick: () => {
            remove(curso.codCurso).then((data) => {
              if (!data || data.error) {
                errorMessage(
                  mensagemDe(
                    data,
                    "O curso não pode ser removido pois possui turmas cadastradas. Remova todas as turmas cadastradas com este curso.",
                  ),
                );
                return;
              }
              setCursos((prevState) => prevState.filter((c) => c.codCurso !== curso.codCurso));
              success("Curso removido.");
            });
          },
        },
        { label: "Não", onClick: () => {} },
      ],
    });

  return (
    <Container>
      <CursoForm curso={editando} onClose={() => setEditando(null)} onSave={handleSave} isSaving={isSaving} />

      <Stack
        direction={{ xs: "column", sm: "row" }}
        justifyContent="space-between"
        alignItems={{ xs: "flex-start", sm: "center" }}
        spacing={2}
        mb={3}
      >
        <Box>
          <Typography variant="h6">Cursos</Typography>
          <Typography variant="body2" color="text.secondary">
            Cursos oferecidos pela instituição, usados no cadastro de séries e turmas.
          </Typography>
        </Box>
        <Button variant="contained" startIcon={<AddIcon />} onClick={() => setEditando({ eNovo: true })}>
          Novo Curso
        </Button>
      </Stack>

      <CursoTable cursos={cursos} isLoading={isLoading} onEdit={setEditando} onDelete={handleDelete} />
    </Container>
  );
}
